import axios from "axios";
import { VIZY_AUTH_TOKEN_REFRESH } from "./url";

const TOKEN_KEY = "vizy-bility-token";
const REFRESH_KEY = "vizy-refresh-token";

let _isRefreshing = false;
let _refreshQueue = [];

const processQueue = (err, token = null) => {
  _refreshQueue.forEach((p) => (err ? p.reject(err) : p.resolve(token)));
  _refreshQueue = [];
};

const refreshAndRetry = async (retryFn) => {
  if (!localStorage.getItem("vizy-keep-signed-in")) {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(REFRESH_KEY);
    if (window.location.pathname !== "/") window.location.href = "/";
    throw new Error("Session expired");
  }

  if (_isRefreshing) {
    return new Promise((resolve, reject) =>
      _refreshQueue.push({ resolve, reject })
    ).then((token) => retryFn(token));
  }

  _isRefreshing = true;
  try {
    const currentToken = localStorage.getItem(TOKEN_KEY);
    const refreshToken = localStorage.getItem(REFRESH_KEY);
    if (!refreshToken) throw new Error("No refresh token");

    const res = await axios.post(VIZY_AUTH_TOKEN_REFRESH, {
      token: currentToken,
      refreshToken,
    });
    const data = res.data?.data ?? res.data;
    const newToken = data?.token || data?.Token;
    const newRefresh = data?.refreshToken || data?.RefreshToken;
    if (!newToken) throw new Error("No token returned from refresh");

    localStorage.setItem(TOKEN_KEY, newToken);
    if (newRefresh) localStorage.setItem(REFRESH_KEY, newRefresh);

    processQueue(null, newToken);
    return retryFn(newToken);
  } catch (refreshErr) {
    processQueue(refreshErr, null);
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(REFRESH_KEY);
    if (window.location.pathname !== "/") window.location.href = "/";
    throw refreshErr;
  } finally {
    _isRefreshing = false;
  }
};

// Signature kept compatible — instance/accounts no longer used
const get = async (url, headers = {}) => {
  try {
    return await axios.get(url, { headers });
  } catch (err) {
    if (err?.response?.status === 401) {
      return refreshAndRetry((newToken) =>
        axios.get(url, {
          headers: { ...headers, authorization: `Bearer ${newToken}` },
        })
      );
    }
    throw err;
  }
};

// eslint-disable-next-line import/no-anonymous-default-export
export default { get };
